export const MEETING_SERIES_PAGE_SIZE = 10;



// WEBPACK FOOTER //
// ./src/store/modules/schedule/constants.js